import { useState, useCallback } from 'react';
import { useBetween } from 'use-between';

function IsMenuOpen() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const doOpenMenu = useCallback(() => setIsMenuOpen(true), []);
  const doHideMenu = useCallback(() => setIsMenuOpen(false), []);
  return {
    isMenuOpen,
    doOpenMenu,
    doHideMenu
  };
};
const useSharedIsMenuOpen= () => useBetween(IsMenuOpen);

export default useSharedIsMenuOpen;
